import styled from 'styled-components';

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
`;

export const InputLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: clamp(0.7rem, calc(0.7rem + 0.08vw), 0.85rem);
`;

export const InputData = styled.input`
  border: none;
  outline: none;
  background-color: #ebebeb;
  height: 2rem;
  padding: 0 0.75rem;
  border-radius: 1.25rem;
  font-size: 0.8125rem;
  font-family: 'Inter', sans-serif;
`;
